module.exports = __webpack_public_path__ + "img/sankaku_40_blue.24ddc6a9.png";